import { render, staticRenderFns } from "./OutsourcePick.vue?vue&type=template&id=28a07cfb"
import script from "./OutsourcePick.vue?vue&type=script&lang=js"
export * from "./OutsourcePick.vue?vue&type=script&lang=js"
import style0 from "./OutsourcePick.vue?vue&type=style&index=0&id=28a07cfb&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports